<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="authentication-wrapper authentication-basic container-p-y">
            <div class="authentication-inner">
                <div class="container">
                    <mat-card class="center">
                        <mat-card-title>
                            <h2 class="mt-3 mb-4"><img src="../../../assets/avatars/2.png" style="width: 30px;">
                                Registration </h2>
                        </mat-card-title>

                        <mat-card-content>
                            <form [formGroup]="registrationForm" (ngSubmit)="register()">
                                <div class="form-group">
                                    <label for="FirstName" class="form-label">First Name</label>
                                    <mat-form-field appearance="outline" class="form-field" style="width:100%">
                                        <mat-label>Enter Your First Name</mat-label>
                                        <input matInput type="text" formControlName="FirstName" name="FirstName"
                                            id="FirstName"
                                            [ngClass]="{'is-invalid':submitted && forms.FirstName.errors}" autofocus>
                                        <mat-error *ngIf="submitted && forms.FirstName.errors" class="invalid-feedback">
                                            <div *ngIf="forms.FirstName.errors.required">FirstName is required</div>
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="form-group">
                                    <label for="LastName" class="form-label">Last Name</label>
                                    <mat-form-field appearance="outline" class="form-field" style="width:100%">
                                        <mat-label>Enter Your Last Name</mat-label>
                                        <input matInput type="text" formControlName="LastName" name="LastName"
                                            id="LastName" [ngClass]="{'is-invalid':submitted && forms.LastName.errors}"
                                            required autofocus>
                                        <mat-error *ngIf="submitted && forms.LastName.errors" class="invalid-feedback">
                                            <div *ngIf="forms.LastName.errors.required">LastName is required</div>
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <div class="form-group">
                                    <label for="Email" class="form-label">Email</label>
                                    <mat-form-field appearance="outline" class="form-field" style="width:100%">
                                        <mat-label>Enter Your Email</mat-label>
                                        <input matInput type="email" formControlName="Email" name="Email" id="Email"
                                            [ngClass]="{'is-invalid':submitted && forms.Email.errors}" required
                                            autofocus>
                                        <mat-error *ngIf="submitted && forms.Email.errors" class="invalid-feedback">
                                            <div *ngIf="forms.Email.errors.required">Email is required</div>
                                            <div *ngIf="forms.Email.errors.email">Email must be a valid email address
                                            </div>
                                        </mat-error>
                                    </mat-form-field>
                                </div>

                                <label for="Password" class="form-label">Password</label>
                                <mat-form-field appearance="outline" class="form-field" style="width:100%">
                                    <mat-label>Enter Your Password</mat-label>
                                    <input matInput [type]="hide ? 'password' : 'text'" name="Password"
                                        formControlName="Password"
                                        [ngClass]="{'is-invalid':submitted && forms.Password.errors}" required
                                        autofocus>

                                    <mat-error *ngIf="submitted && forms.Password.errors" class="invalid-feedback">

                                        <div *ngIf="forms.Password.errors.required">Password is required</div>
                                        <div *ngIf="forms.Password.errors.minlength"></div>
                                        <div class="error-text"
                                            *ngIf="registrationForm.get('Password').hasError('passwordStrength')">
                                            {{registrationForm.get('Password').errors['passwordStrength']}}
                                        </div>
                                    </mat-error>

                                    <button mat-icon-button matSuffix (click)="hide = !hide" type="button"
                                        [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
                                    </button>
                                </mat-form-field>


                                <mat-checkbox color="primary" style="margin-top: 10px; margin-bottom: 15px;"
                                    #confirmed>I
                                    agree to <a href="/" style="text-decoration: none;"> privacy policy &
                                        terms</a>
                                </mat-checkbox>
                                <div class="mb-3 password">
                                    <div *ngIf="this.registrationForm.get('Password').invalid">
                                        Password must contain all of the following:<br>
                                        Numbers, Lowercase letters,
                                        Uppercase letters, or special characters and must be at least 6 characters.
                                    </div>
                                </div>
                                <alert></alert>
                                <button class="btn btn-primary d-grid w-100 mt-3 mb-3" type="submit"
                                    [disabled]="!confirmed.checked">Sign up
                                </button>
                                <p class="text-center">
                                    <span>Already have an account ? </span>
                                    <a href="/#/signin" style="text-decoration: none;">
                                        <span>Sign in instead</span>
                                    </a>
                                </p>
                                <p style="text-align: center; color: brown;">
                                    Company details will be taken in sub sequences screen!
                                </p>
                            </form>
                        </mat-card-content>
                    </mat-card>
                </div>
            </div>
        </div>
    </div>